import { User, Project } from '../types'

// 檢查用戶是否可以查看專案預算
export const canViewProjectBudget = (user: User | null, project: Project): boolean => {
  if (!user || !project.budget) {
    return false
  }

  // 1. 管理員永遠可以看
  if (user.role === 'ADMIN') {
    return true
  }
  
  // 2. 主管永遠可以看  
  if (user.role === 'MANAGER') {
    return true
  }
  
  // 3. 專案創建者永遠可以看
  if (project.createdBy === user.id) {
    return true
  }
  
  // 4. 專案擁有者永遠可以看
  const isOwner = project.members?.some(member => 
    member.userId === user.id && member.role === 'owner'
  )
  if (isOwner) {
    return true
  }
  
  // 5. 一般成員：只有設定顯示才能看
  return project.budget?.showBudgetToMembers === true
}

// 檢查用戶是否可以編輯專案
export const canEditProject = (user: User | null, project: Project): boolean => {
  if (!user) {
    return false
  }

  // 管理員可以編輯所有專案
  if (user.role === 'ADMIN') {
    return true
  }

  // 主管可以編輯專案
  if (user.role === 'MANAGER') {
    return true
  }

  // 專案創建者可以編輯
  if (project.createdBy === user.id) {
    return true
  }

  return false
}

// 檢查用戶是否可以刪除專案
export const canDeleteProject = (user: User | null, project: Project): boolean => {
  if (!user) {
    return false
  }

  // 管理員可以刪除所有專案
  if (user.role === 'ADMIN') {
    return true
  }

  // 主管可以刪除專案
  if (user.role === 'MANAGER') {
    return true
  }

  // 專案創建者可以刪除
  if (project.createdBy === user.id) {
    return true
  }

  return false
}

// 獲取預算顯示狀態文字
export const getBudgetVisibilityText = (project: Project): string => {
  if (!project.budget) {
    return ''
  }

  return project.budget.showBudgetToMembers ? '成員可見' : '僅管理層'
}

// 獲取預算顯示狀態圖示
export const getBudgetVisibilityIcon = (project: Project): string => {
  if (!project.budget) {
    return ''
  }

  return project.budget.showBudgetToMembers ? '👥' : '🔒'
}
